import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BusinessUnit, ComponentSizes, PcButtonIcon } from '@pc/common';
import { ButtonDateType, DepartureReturnButtonState } from './button-state.enum';
import { DepartureReturnBtnCardComponent } from './departure-return-btn-card/departure-return-btn-card.component';
import { DatesDetailsType } from './departure-return-detail-type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pc-departure-return-button',
  standalone: true,
  imports: [CommonModule, DepartureReturnBtnCardComponent, TranslateModule],
  templateUrl: './departure-return-button.component.html',
  styleUrl: './departure-return-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartureReturnButtonComponent {
  @Input() public datesDetails: DatesDetailsType | undefined = undefined;
  @Input({ required: true }) public buttonState: DepartureReturnButtonState = DepartureReturnButtonState.None;
  @Input({ required: true }) public activeState: DepartureReturnButtonState = DepartureReturnButtonState.None;
  @Input({ required: true }) public dateEditText!: string;
  @Input({ required: true }) public departureAltText!: string;
  @Input({ required: true }) public returnAltText!: string;
  @Input({ required: true }) public buttonImage = PcButtonIcon.WHEN_RECTANGLE;
  @Input({ required: true }) public buttonImageDesktop = PcButtonIcon.WHEN_RECTANGLE_DESK;
  @Input() public activeImageText = { from: 'Start Date', to: 'End Date' };
  @Input() public size: ComponentSizes = 'xsmall';
  @Input() public editFromDateDescription!: string;
  @Input() public editToDateDescription!: string;
  @Input() public showButtonImageAirplane = true;
  @Input() public businessUnit = BusinessUnit.IL;
  @Input() public isLTR = false;

  @Output() editDates = new EventEmitter<DepartureReturnButtonState>();

  public readonly ButtonState = DepartureReturnButtonState;
  public readonly ButtonDateType = ButtonDateType;
  public readonly PcButtonIcon = PcButtonIcon;

  public editSelectedDates(event: DepartureReturnButtonState) {
    this.editDates.emit(event);
  }
}
